var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96719 9.05156C6.60719 9.05156 6.36719 8.81156 6.36719 8.45156V5.45156C6.36719 5.09156 6.60719 4.85156 6.96719 4.85156C7.32719 4.85156 7.56719 5.09156 7.56719 5.45156V8.45156C7.56719 8.81156 7.32719 9.05156 6.96719 9.05156Z",
    fill: "url(#paint0_linear_3396_1303)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96719 4.25078C7.29856 4.25078 7.56719 3.98215 7.56719 3.65078C7.56719 3.31941 7.29856 3.05078 6.96719 3.05078C6.63582 3.05078 6.36719 3.31941 6.36719 3.65078C6.36719 3.98215 6.63582 4.25078 6.96719 4.25078Z",
    fill: "url(#paint1_linear_3396_1303)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 12.0508C3.66875 12.0508 0.96875 9.35078 0.96875 6.05078C0.96875 2.75078 3.66875 0.0507812 6.96875 0.0507812C10.2688 0.0507812 12.9688 2.75078 12.9688 6.05078C12.9688 9.35078 10.2688 12.0508 6.96875 12.0508ZM6.96875 1.25078C4.32875 1.25078 2.16875 3.41078 2.16875 6.05078C2.16875 8.69078 4.32875 10.8508 6.96875 10.8508C9.60875 10.8508 11.7688 8.69078 11.7688 6.05078C11.7688 3.41078 9.60875 1.25078 6.96875 1.25078Z",
    fill: "url(#paint2_linear_3396_1303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3396_1303",
    x1: 6.96719,
    y1: 4.85156,
    x2: 6.96719,
    y2: 9.05156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2479DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3396_1303",
    x1: 6.96719,
    y1: 3.05078,
    x2: 6.96719,
    y2: 4.25078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2479DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3396_1303",
    x1: 6.96875,
    y1: 0.0507812,
    x2: 6.96875,
    y2: 12.0508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2479DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2479DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2d0bf9b1237b3f40a77e83720b9dac94.svg";
export { ForwardRef as ReactComponent };